/**
 * Fragment id of the landing's closing download section, the desktop target of every "Get the app"
 * link (`/download` sends desktops to `/#download`).
 */
export const LANDING_DOWNLOAD_SECTION_ID = "download";
